import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  talentAccreditations: null,
  loading: false,
  total: 0,
};

function formatAccreditations(accreditations) {
  return accreditations.map(accreditation => {
    return {
      ...accreditation,
      children: accreditation.children && accreditation.children.length ? accreditation.children : undefined,
    };
  });
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;

  return {
    ...state,
    data: formatAccreditations(data),
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function removeAccreditationSuccess(state, { payload }) {
  return { ...state, data: state.data.filter(item => item.id !== payload.id) };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.DELETE_ACCREDITATION_SUCCESS]: removeAccreditationSuccess,
});
